import { css } from 'styled-components';
import Responsive from 'react-responsive';
import React from 'react';

const sizes = {
  desktop: 992,
  tablet: 768,
  phone: 376,
};

export const Desktop = (props) => <Responsive {...props} minWidth={sizes.desktop} />;
export const TabletUp = (props) => <Responsive {...props} minWidth={sizes.tablet} />;
export const Tablet = (props) => <Responsive {...props} minWidth={sizes.tablet} maxWidth={sizes.desktop - 1} />;
export const Mobile = (props) => <Responsive {...props} maxWidth={sizes.tablet - 1} />;


// TODO: @madalena i didn't understood the current breakpoint (media.tablet was everything under or equal 768)
// since we currently only use this one, i change it (-1) and rename it to mobile or phone.
// on the other hand i would prefer mobile first and use tabletUp instead of mobile
export const media = {
  tablet: (...args) => css`
    @media (max-width: ${(sizes.tablet - 1) / 16}em) {
      ${css(...args)}
    }
  `,
};

export default media;



// WEBPACK FOOTER //
// ./src/media.js